/* Search results */
.sb-results {
	position: fixed;
	list-style: none;
	margin: 0;
	padding: 0;
	max-width: calc(100% - 20px);
	border: 1px solid var(--widget-border-div);
	border-radius: 10px;
	background-color: var(--widget-bg);
	color: var(--widget-font);
	z-index: 130;
	font-size: 1.05em;
	line-height: normal;
	font-family: var(--font-family);
	max-height: 30vh;
	overflow-y: auto;
}
.sb-result,
.sb-empty {
	display: block;
	padding: 5px 15px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	cursor: pointer;
	border-radius: 0;
}
.sb-result:hover {
	background-color: var(--widget-bg-hover);
}
.sb-result:first-child {
	border-top-right-radius: 10px;
	border-top-left-radius: 10px;
	padding-top: 15px;
}
.sb-result:last-child {
	border-bottom-right-radius: 10px;
	border-bottom-left-radius: 10px;
	padding-bottom: 15px;
}